import { gql } from '@apollo/client';
import { DriverAddressInput } from './assignDrivers';

export interface ClusteringDriverInput {
    driverAccountId: number;
    capacityMin: number;
    capacityMax: number;
    preferredZipcodes: string[];
    startAddress?: DriverAddressInput | null;
    endAddress?: DriverAddressInput | null;
}

export interface SubmitClusteringTaskRequestInput {
    warehouseId: number;
    areaId: number;
    drivers: ClusteringDriverInput[];
}

export interface ClusteringSegmentResult {
    driverAccountId: number;
    assignedOrderIds: number[];
    totalParcelCount: number;
    parcelNumberStart: number;
    parcelNumberEnd: number;
}

export interface SubmitClusteringTaskOutput {
    segments: ClusteringSegmentResult[];
}

export interface SubmitClusteringTaskResponse {
    submitClusteringTask: SubmitClusteringTaskOutput;
}

export interface SubmitClusteringTaskVariables {
    request: SubmitClusteringTaskRequestInput;
}

export const SUBMIT_CLUSTERING_TASK = gql`
    mutation SubmitClusteringTask($request: SubmitClusteringTaskRequestInput!) {
        submitClusteringTask(request: $request) {
            segments {
                driverAccountId
                assignedOrderIds
                totalParcelCount
                parcelNumberStart
                parcelNumberEnd
            }
        }
    }
`;
